import { LoaddingService } from './../../providers/loadding.service';
import { VrService } from './../../services/vr.service';
import { NavParams, ViewController, Loading } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'chaseorderdetail.html',
    providers: [VrService]
})
export class ChaseOrderDetailPage {
    order;
    states = [];
    orderDetails = [];
    moneyMode = [
        { money: 1, name: '1元' },
        { money: 2, name: '2元' },
        { money: 0.1, name: '1角' },
        { money: 0.2, name: '2角' },
        { money: 0.02, name: '2分' }
    ];
    detailstates = [
        { code: 0, name: '未颁奖' },
        { code: 1, name: '撤单' },
        { code: 2, name: '未中奖' },
        { code: 3, name: '已中奖' },
        { code: 4, name: '未投注' },
        { code: 5, name: '取消投注' },
        { code: 6, name: '中后取消投注' }
    ];
    constructor(
        private viewctrl: ViewController,
        private navpars: NavParams,
        private vrService: VrService,
        private loading: LoaddingService
    ) {
        this.order = this.navpars.get('order');
        this.states = this.navpars.get('states');
        let load = this.loading.showLoding();
        this.vrService.getBetReportByChase({ userName: this.navpars.get('userName'), ChaseSerialNumber: this.order.ChaseSerialNumber }).then(s => {
            if (s && s.List && s.List.length > 0) {
                this.orderDetails = s.List;
                this.orderDetails.forEach(d => {
                    d.UnitName = this.moneyMode.find(f => f.money === d.Unit).name;
                });
            }
            this.loading.closeLoading(load);
        }).catch(() => {
            this.loading.closeLoading(load);
        });
    }

    dismiss() {
        this.viewctrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/vrchasereport/chaseorderdetail.ts